import request from 'superagent';
import url from '../../utils/url';
import createReducer from '../reducers/createReducer';


const actions = {
  REQUEST_SIDEBAR_DATA: 'REQUEST_SIDEBAR_DATA',
  RECEIVE_SIDEBAR_DATA: 'RECEIVE_SIDEBAR_DATA',
  SIDEBAR_DATA_ERROR: 'SIDEBAR_DATA_ERROR',
};

export const getSidebarData = (params = {}) => (dispatch) => {
  dispatch({
    type: actions.REQUEST_SIDEBAR_DATA,
    data: { status: 'loading' },
  });

  const onSuccess = (resp) => {
    const { data = {} } = resp.body;
    dispatch({
      type: actions.RECEIVE_SIDEBAR_DATA,
      data: { ...data, status: 'done' },
    });
  };

  const onFailure = (error) => {
    dispatch({
      type: actions.SIDEBAR_DATA_ERROR,
      error,
    });
  };

  const { type = 'filings' } = params;

  return request
    .get(url(`/ui/sidebar?url=${type}`))
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json')
    .then(onSuccess, onFailure);
};

const initSidebarData = {
  status: '',
};

export const sidebarData = createReducer(initSidebarData, {
  [actions.REQUEST_SIDEBAR_DATA]: (state, action) => {
    return { ...state, ...action.data };
  },
  [actions.RECEIVE_SIDEBAR_DATA]: (state, action) => {
    return { ...action.data };
  },
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/sidebarActions.js
 **/